import { render, staticRenderFns } from "./NsIcon.vue?vue&type=template&id=0464f796&scoped=true&"
import script from "./NsIcon.vue?vue&type=script&lang=js&"
export * from "./NsIcon.vue?vue&type=script&lang=js&"
import style0 from "./NsIcon.vue?vue&type=style&index=0&id=0464f796&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0464f796",
  null
  
)

export default component.exports